import { Observable } from 'rxjs';
import { StorageParameters } from '../storage.service';
import { ApiBase } from './api.base';
import { AuctionItem } from '../../models/auction-item';
import { Bid } from '../../models/bid';
import { Auction } from '../../models/auction';

export class AuctionsItemsApi extends ApiBase {
  model = 'admin/items';

  public patch(id: string, data?: AuctionItem): Observable<AuctionItem> {
    return this.http.patch<Auction>(this.buildUrl(id), data, {
      headers: this.setHeaders({
        Authorization: this.getStorage().getItem(
          StorageParameters.AccessTokenId
        ),
      }),
    });
  }

  public deleteById(id: string): Observable<{ count: number }> {
    return this.http.delete<{ count: number }>(this.buildUrl(id), {
      headers: this.setHeaders({
        Authorization: this.getStorage().getItem(
          StorageParameters.AccessTokenId
        ),
      }),
    });
  }

  public getBids(id: string): Observable<Bid[]> {
    return this.http.get<Bid[]>(this.buildUrl(id, 'bids'), {
      headers: this.setHeaders({
        Authorization: this.getStorage().getItem(
          StorageParameters.AccessTokenId
        ),
      }),
    });
  }

  public getDeluxeIntegration(id: string) {
    return this.http.get<{ integrationId: string }>(
      this.buildUrl(id, 'deluxe-integration'),
      {
        headers: this.setHeaders({
          Authorization: this.getStorage().getItem(
            StorageParameters.AccessTokenId
          ),
        }),
      }
    );
  }

  public bidDeleteById(
    id: string,
    bidId: string
  ): Observable<{ count: number }> {
    return this.http.delete<{ count: number }>(
      this.buildUrl(id, 'bid', 'deleteById', bidId),
      {
        headers: this.setHeaders({
          Authorization: this.getStorage().getItem(
            StorageParameters.AccessTokenId
          ),
        }),
      }
    );
  }
}
